import React, { useCallback } from "react";
import { Input } from "components/bootstrap";
import UploadFieldContainer from "./UploadField/UploadFieldContainer";
function UploadCSVFileAdapterFieldSet({ config, setFieldValue }) {
  const valueLabel = config.multi_value_lookup ? "Value columns" : "Value column";
  const valueHelp = config.multi_value_lookup ? "The column names that should be used as the values for a key, or leave empty for all columns except the key." : "The column name that should be used as the value for a key.";
  const _onFileUpdate = useCallback(
    (fileId) => {
      if (fileId) setFieldValue("config.file_id", fileId);
    },
    [setFieldValue]
  );
  const onInputChange = (e) => {
    setFieldValue(`config.${e.target.name}`, e.target.type === "checkbox" ? e.target.checked : e.target.value);
  };
  return /* @__PURE__ */ React.createElement("fieldset", null, /* @__PURE__ */ React.createElement(
    UploadFieldContainer,
    {
      onUpdate: _onFileUpdate,
      fileId: config.file_id,
      setDisableFormSubmission: () => !!config.file_id,
      accept: ".csv"
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "text",
      id: "separator",
      name: "separator",
      label: "Separator",
      required: true,
      onChange: onInputChange,
      help: "The delimiter to use for separating entries.",
      value: config.separator,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "text",
      id: "quotechar",
      name: "quotechar",
      label: "Quote character",
      required: true,
      onChange: onInputChange,
      help: "The character to use for quoted elements.",
      value: config.quotechar,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "text",
      id: "key_column",
      name: "key_column",
      label: "Key column",
      required: true,
      onChange: onInputChange,
      help: "The column name that should be used for the key lookup.",
      value: config.key_column,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "text",
      id: "value_column",
      name: "value_column",
      label: valueLabel,
      required: !config.multi_value_lookup,
      onChange: onInputChange,
      help: valueHelp,
      value: config.value_column,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "checkbox",
      id: "multi_value_lookup",
      name: "multi_value_lookup",
      label: "Multi-value lookup",
      checked: !!config.multi_value_lookup,
      onChange: onInputChange,
      help: "Enable for multiple value columns.",
      wrapperClassName: "col-md-offset-3 col-md-9"
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "checkbox",
      id: "case_insensitive_lookup",
      name: "case_insensitive_lookup",
      label: "Allow case-insensitive lookups",
      checked: !!config.case_insensitive_lookup,
      onChange: onInputChange,
      help: "Enable if the key lookup should be case-insensitive.",
      wrapperClassName: "col-md-offset-3 col-md-9"
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "checkbox",
      id: "cidr_lookup",
      name: "cidr_lookup",
      label: "CIDR lookup",
      checked: !!config.cidr_lookup,
      onChange: onInputChange,
      help: "Enable if the keys in the lookup table are in CIDR notation and lookups will be done with IPs",
      wrapperClassName: "col-md-offset-3 col-md-9"
    }
  ));
}
export default UploadCSVFileAdapterFieldSet;
